import { render, staticRenderFns } from "./Cosmetic.vue?vue&type=template&id=0d6a8602&"
import script from "./Cosmetic.vue?vue&type=script&lang=js&"
export * from "./Cosmetic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports